import React, { Component } from 'react'
import {withRouter} from 'react-router-dom'
import Badge from '@material-ui/core/Badge'
import { authorTitleEdit, ReleasedIcon, UnreleasedIcon, PreviewEyeIcon, SaveIcon, publicationPageIcon, allAlerts, editTags} from '../../../../Templates/icons'
import EditTitleFormContainer from './edit_title_form_container'
class Toolbar extends Component {
    state = {
        editingTitle: false,
    }

    handleClick = (e) => {
        e.stopPropagation()
        this.props.saveWorkInstruction()
    }

    renderWorkInstructionTitle = (WITitle) => {  
        return <div id="editor-header" className="flex">
                    {this.state.editingTitle ? 
                        <EditTitleFormContainer 
                            title={WITitle} 
                            cancel={() => this.setState({editingTitle: false})}
                            submitTitleEdit={this.submitTitleEdit}/> 
                    : 
                        authorTitleEdit(() => this.setState({ editingTitle: true }), WITitle)
                    }
        </div>
    }

    renderReleaseIcon = () => {
        let toggleRelease = () => this.props.toggleRelease(this.props.match.params.WIID)
        return this.props.isReleased ?
                //in released state, will trigger unrelease action
                <span id="editor-options-icon-container" className="flex-align clickable" onClick={toggleRelease}>
                {ReleasedIcon(true)}
            </span>
            :
            //in unreleased state, will trigger release action
            <span id="editor-options-icon-container" className="flex-align clickable" onClick={toggleRelease}>
                {UnreleasedIcon(true)}
            </span>
    }

    render() {
        const { previewWorkInstruction, nullOptions, togglePublicationPage, currentWorkInstructionTags, toggleAllAlertsPage} = this.props
        let numTags = currentWorkInstructionTags ? currentWorkInstructionTags.length : 0
        return nullOptions ? null : 
            <div id={this.props.isPDFWip?"editor-options-pdfWIp": "editor-options"} className="flex-align flex-apart">

               {/* <div className="editor-options-box"> 
                    <div className="flex-WI-ToolBars clickable" id="all-alerts-container" onClick={toggleAllAlertsPage} >
                        {allAlerts}
                    </div>
                </div> */}

                {/* <div className="editor-options-box leftWhiteBorder">
                    <div className="flex-WI-ToolBars clickable autoMarginsLR" id="edit-tags-container" onClick={this.props.toggleEditTags} >
                            <Badge id="wiAuthorTagID" badgeContent={numTags}  anchorOrigin={{vertical: 'top',horizontal: 'left' }}  color="primary">
                                {editTags}
                            </Badge>                       
                    </div>
                </div> */}

                <div className="editor-options-box ">
                    <div className="flex-WI-ToolBars clickable " id="save-button-container" onClick={this.handleClick} onContextMenu={this.props.toggleAutoSave}>
                        
                        {/* <span id="editor-options-icon-container" className="flex-align clickable" */}
                            
                        
                            {SaveIcon(this.props.isSavable, this.props.hasAutoSave)}
                        {/* </span> */}
                    </div> 
                </div>

                {/* <div className="editor-options-box leftWhiteBorder">
                    <div className="flex-WI-ToolBars clickable" id="preview-button-container" onClick={previewWorkInstruction}>
                        
                            {PreviewEyeIcon}
                        
                    </div>
                </div> */}

                <div className="editor-options-box leftWhiteBorder">
                    <div className="flex-WI-ToolBars clickable" id="publication-page-container" onClick={togglePublicationPage}>
                        {/* <span id="editor-options-icon-container" className="flex-align clickable" > */}
                            {publicationPageIcon}
                        {/* </span> */}
                    </div>
                </div>

            </div>
    }
}

export default withRouter(Toolbar)